var _g, _rect, _g2, _rect2, _g3, _path, _path2, _rect3, _path3, _path4, _rect4, _rect5, _rect6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGetstartedWorkproduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 62,
    viewBox: "0 0 93 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_212_53)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.5151,
    y: 3.29102,
    width: 13.9722,
    height: 52.4588,
    rx: 1,
    fill: "#7FC1B5"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.4875,
    y: 0.339844,
    width: 16.2178,
    height: 55.3771,
    rx: 1,
    fill: "#194A5F"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_212_53)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41.7053,
    y: 3.2583,
    width: 13.3155,
    height: 52.4588,
    rx: 1,
    fill: "#71CC8B"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.875,
    y: 61.75,
    width: 6.00001,
    height: 91.25,
    transform: "rotate(-90 0.875 61.75)",
    fill: "#799296"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_212_53)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.1859,
    height: 52.1003,
    rx: 1,
    transform: "matrix(0.951901 -0.306406 0.285301 0.958438 55.0208 5.81494)",
    fill: "#96BBBE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.3061 6.77338C55.1485 6.24405 55.4469 5.67776 55.9727 5.50854L65.6686 2.38751C66.1944 2.21829 66.7483 2.51021 66.9058 3.03954L68.2962 7.71027L56.6964 11.4441L55.3061 6.77338Z",
    fill: "#769EA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1965 51.022C81.3558 51.5508 81.0591 52.118 80.5339 52.2889L70.8479 55.4405C70.3227 55.6114 69.7678 55.3213 69.6086 54.7924L68.2843 50.3945L79.8722 46.624L81.1965 51.022Z",
    fill: "#769EA0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5151,
    y: 42.2246,
    width: 13.8659,
    height: 6.10087,
    fill: "#98D3C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4875 45.2163H41.7053V54.7168C41.7053 55.2691 41.2576 55.7168 40.7053 55.7168H26.4875C25.9353 55.7168 25.4875 55.2691 25.4875 54.7168V45.2163Z",
    fill: "#476876"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7053 10.8403L25.4876 10.8403L25.4876 1.33979C25.4876 0.787506 25.9353 0.339792 26.4876 0.339792L40.7053 0.339793C41.2576 0.339793 41.7053 0.787508 41.7053 1.33979L41.7053 10.8403Z",
    fill: "#476876"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5151,
    y: 10.6646,
    width: 13.8659,
    height: 6.10087,
    fill: "#98D3C9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 35.4578,
    y: 15.9438,
    width: 23.5236,
    height: 3.72256,
    transform: "rotate(90 35.4578 15.9438)",
    fill: "#7CA4B5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 50.2244,
    y: 12.625,
    width: 32.5917,
    height: 3.72256,
    rx: 1.86128,
    transform: "rotate(90 50.2244 12.625)",
    fill: "#F0F6F8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_212_53",
    x: 9.51514,
    y: 3.29102,
    width: 17.9722,
    height: 56.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_212_53"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_212_53",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_212_53",
    x: 39.7053,
    y: 3.2583,
    width: 17.3154,
    height: 56.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_212_53"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_212_53",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_212_53",
    x: 53.2639,
    y: 2.33936,
    width: 29.9775,
    height: 57.1523,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.783105 0 0 0 0 0.783105 0 0 0 0 0.783105 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_212_53"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_212_53",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetstartedWorkproduct);
export default __webpack_public_path__ + "static/media/getstarted-workproduct.649017f725c3f4d789b41a2183f4d994.svg";
export { ForwardRef as ReactComponent };